import React from "react";

const Line = () => {
  return (
    <div className="border-b border-dashed  border-[#707070] border-opacity-[38%]"></div>
  );
};

export default Line;
